<router-outlet></router-outlet>

<app-loader></app-loader>

<app-back-to-top></app-back-to-top>